import type * as React from 'react';

import { Icon } from '@gitbook/spine-icons';
import { Button, type TreeData } from '@gitbook/spine-react';

export function DeleteTreeItemButton<T extends TreeData<object>>(props: {
    treeRef: React.MutableRefObject<T>;
    item: T['items'][number];
    label: string;
}) {
    const { treeRef, item } = props;
    return (
        <Button
            iconOnly
            kind="blank"
            size="small"
            leadingIcon={Icon.Trashcan}
            label={props.label}
            onPress={() => {
                treeRef.current.remove(item.key);
            }}
        />
    );
}
